export const LOGO = "https://customer-assets-4nw71qhi.emergentagent.net/job_tori-zeeland/artifacts/9qu2p9ai_IMG_3693.jpeg";

export const DISHES = [
  {
    id: "nasi_bbq_kip",
    name: "Nasi BBQ Kip",
    price: 14.5,
    desc: "Surinaamse nasi met malse kip in onze huisgemaakte BBQ-marinade.",
    image: "https://static.prod-images.emergentagent.com/jobs/97cd27e6-da1b-4061-9ccc-946ea26260dc/images/2220ce8309bb1cd2d925e5ed388bec865e081801e8a19897e1f7d6ec3290bc92.png",
  },
  {
    id: "bami_bbq_kip",
    name: "Bami BBQ Kip",
    price: 14.5,
    desc: "Surinaamse bami met malse kip in onze huisgemaakte BBQ-marinade.",
    image: "https://static.prod-images.emergentagent.com/jobs/97cd27e6-da1b-4061-9ccc-946ea26260dc/images/9a156c36a259adcd21ebdcc614f0341bc886d622c5548d7e929e85fdc3d17598.png",
  },
  {
    id: "patat_bbq_kip",
    name: "Patat BBQ Kip",
    price: 14.5,
    desc: "Krokante patat met malse kip in onze huisgemaakte BBQ-marinade.",
    image: "https://static.prod-images.emergentagent.com/jobs/97cd27e6-da1b-4061-9ccc-946ea26260dc/images/2735039adeeb37fc2c9262766dff4f99885d09cd4c36340bdccf96bbaaf3ec9b.png",
  },
  {
    id: "witte_rijst_chinese_kip",
    name: "Witte Rijst Chinese Kip",
    price: 14.5,
    desc: "Witte rijst met sappige Chinese kip, licht zoet en vol van smaak.",
    image: "https://static.prod-images.emergentagent.com/jobs/97cd27e6-da1b-4061-9ccc-946ea26260dc/images/3f7b7be497989781048cc439f1802fe84e5e4366027ceb96e4cea1ea030c5be5.png",
  },
];

export const PHOTO_GRID = [
  "https://images.pexels.com/photos/28736727/pexels-photo-28736727.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1679279726946-a158b8bcaa23?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  "https://images.pexels.com/photos/13141439/pexels-photo-13141439.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/28173586/pexels-photo-28173586.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/38376791/pexels-photo-38376791.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/24778216/pexels-photo-24778216.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/27259158/pexels-photo-27259158.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1668665771757-4d42737d295a?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
];

export const DAYS = ["Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag"];
export const TIME_SLOTS = ["14:00–15:00", "15:00–16:00", "16:00–17:00", "17:00–18:00", "18:00–19:00"];
export const MIN_ORDER = 2;

export const formatEuro = (v) => `€${Number(v || 0).toFixed(2).replace(".", ",")}`;

export function formatPickupDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso + "T00:00:00");
    const s = d.toLocaleDateString("nl-NL", { weekday: "long", day: "numeric", month: "long" });
    return s.charAt(0).toUpperCase() + s.slice(1);
  } catch (e) {
    return iso;
  }
}

// "31644582821" -> "06 44 582 821"
export function formatPhone(intl = "31644582821") {
  const national = "0" + String(intl).replace(/^\+?31/, "");
  return national.replace(/(\d{2})(\d{2})(\d{3})(\d{3})/, "$1 $2 $3 $4");
}
export const telHref = (intl = "31644582821") => `tel:+${String(intl).replace(/^\+/, "")}`;

const LAST_ORDER_KEY = "dzt_last_order";

export function saveLastOrder(order) {
  try {
    if (!order || !Array.isArray(order.items)) return;
    const quantities = {};
    order.items.forEach((i) => { if (i.id) quantities[i.id] = i.portions; });
    const payload = {
      quantities,
      pickupDay: order.pickup_day || "",
      timeSlot: order.time_slot || "",
      items: order.items.map((i) => ({ name: i.name, portions: i.portions })),
      total: order.total,
      totalPortions: order.total_portions,
      savedAt: new Date().toISOString(),
    };
    localStorage.setItem(LAST_ORDER_KEY, JSON.stringify(payload));
  } catch (e) {
    console.error("Laatste bestelling opslaan mislukt:", e);
  }
}

export function getLastOrder() {
  try {
    const raw = localStorage.getItem(LAST_ORDER_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || !data.quantities || Object.keys(data.quantities).length === 0) return null;
    return data;
  } catch (e) {
    console.error("Laatste bestelling laden mislukt:", e);
    return null;
  }
}

export function clearLastOrder() {
  try { localStorage.removeItem(LAST_ORDER_KEY); } catch (e) { console.error(e); }
}

export const CUTLERY_PRICE = 1;

export function computeTotals(quantities, dishes = [], cutlery = 0) {
  let subtotal = 0;
  let totalPortions = 0;
  (dishes || []).forEach((d) => {
    const q = quantities[d.id] || 0;
    subtotal += q * d.price;
    totalPortions += q;
  });
  const cutleryCount = Math.max(0, cutlery || 0);
  const cutleryTotal = cutleryCount * CUTLERY_PRICE;
  const total = subtotal + cutleryTotal;
  const vat = (subtotal * 9) / 109;
  return { subtotal, cutleryCount, cutleryTotal, total, vat, totalPortions };
}
